import * as React from "react";
import { ICommonServices } from "../services/ICommonServices";
import { IUser } from "../models";

export const ApplicationContext = React.createContext<IApplicationContext>({Services: null });
export interface IApplicationContext {
    Services: ICommonServices | null;
}